<template>
  <div>
    <keep-alive :include="keep_alive">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "lab",
  data() {
    return {};
  },
  components: {},
  created() {
  },
  mounted() {
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
</style>